const AVAILABLE = 'AVAILABLE'
const PENDING = 'PENDING'
const UNAVAILABLE = 'UNAVAILABLE'
const REQUESTABLE = 'REQUESTABLE'
const REQUESTED = 'REQUESTED'

export const CameraEventAvailability = {
    AVAILABLE,
    PENDING
}

export const CameraEventVideoAvailability = {
    AVAILABLE,
    PENDING,
    UNAVAILABLE,
    REQUESTED,
    REQUESTABLE
}

const DRIVER_DISTRACTED = 'DRIVER_DISTRACTED'
const DRIVER_DROWSY = 'DRIVER_DROWSY'
const DRIVER_EATING = 'DRIVER_EATING'
const DRIVER_FATIGUE = 'DRIVER_FATIGUE'
const DRIVER_MOBILE_PHONE = 'DRIVER_MOBILE_PHONE'
const DRIVER_SEATBELT = 'DRIVER_SEATBELT'
const DRIVER_SMOKING = 'DRIVER_SMOKING'
const DRIVING_CRASH = 'DRIVING_CRASH'
const DRIVING_HARSH_TURN_LEFT = 'DRIVING_HARSH_TURN_LEFT'
const DRIVING_HARSH_TURN_RIGHT = 'DRIVING_HARSH_TURN_RIGHT'
const DRIVING_HARSH_BRAKING = 'DRIVING_HARSH_BRAKING'
const REQUESTED_SOS = 'REQUESTED_SOS'
const REQUESTED_VIDEO = 'REQUESTED_VIDEO'
const DRIVING_TAILGATING = 'DRIVING_TAILGATING'
const DRIVER_CAMERA_COVERED = 'DRIVER_CAMERA_COVERED'
const EXTERNAL_IO_EVENTS = 'EXTERNAL_IO_EVENTS'
const EXTERNAL_INPUT = 'EXTERNAL_INPUT'
const EXTERNAL_OUTPUT = 'EXTERNAL_OUTPUT'
const DRIVING_LANE_WEAVING = 'DRIVING_LANE_WEAVING'

export const CameraEventType = {
    DRIVER_DISTRACTED,
    DRIVER_DROWSY,
    DRIVER_EATING,
    DRIVER_FATIGUE,
    DRIVER_MOBILE_PHONE,
    DRIVER_SEATBELT,
    DRIVER_SMOKING,
    DRIVING_CRASH,
    DRIVING_HARSH_TURN_LEFT,
    DRIVING_HARSH_TURN_RIGHT,
    DRIVING_HARSH_BRAKING,
    REQUESTED_SOS,
    REQUESTED_VIDEO,
    DRIVING_TAILGATING,
    DRIVER_CAMERA_COVERED,
    EXTERNAL_IO_EVENTS,
    EXTERNAL_INPUT,
    EXTERNAL_OUTPUT,
    DRIVING_LANE_WEAVING
}
